import { render, staticRenderFns } from "./QuotesAllActivities.vue?vue&type=template&id=5e965e8e"
import script from "./QuotesAllActivities.vue?vue&type=script&lang=ts"
export * from "./QuotesAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports